"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const mustache_1 = __importDefault(require("mustache"));
const location_1 = require("src/utils/location");
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const question_1 = require("src/utils/question");
const question_models_1 = require("src/types/question-models");
const markdown_1 = require("src/utils/markdown");
function isHaveTemplate(textStr) {
    // все шаблоны содержат {{
    return (textStr.indexOf('{{') !== -1 &&
        // подстанавливаем только заэскейпенные значения
        textStr.indexOf('{{{') === -1 &&
        textStr.indexOf('{{&') === -1);
}
function withTemplate(WrappedComponent) {
    class WithTemplate extends react_1.default.Component {
        constructor(props) {
            super(props);
            this.ctx = {};
            this.applyTemplate = this.applyTemplate.bind(this);
        }
        updateContext() {
            // @ts-expect-error TS(2339): Property 'search' does not exist on type 'Readonly... Remove this comment to see the full error message
            const { search, questions, charLimits } = this.props;
            const parsedParams = (0, location_1.getQueryParams)(search);
            const ctx = {};
            Object.keys(parsedParams).map(paramName => {
                ctx[`get_${paramName}`] = (0, markdown_1.cleaner)(parsedParams[paramName] || '');
            });
            Object.keys(questions).map(questionId => {
                const targetQuestion = (0, question_1.createQuestionModel)(questions, Number(questionId), {
                    charLimits
                });
                const questionAnswer = targetQuestion.getAnswerText();
                ctx[`q_${questionId}`] = (0, markdown_1.cleaner)(questionAnswer || '');
            });
            this.ctx = ctx;
        }
        applyTemplate(tpl) {
            if (tpl === undefined) {
                return '';
            }
            if (isHaveTemplate(tpl)) {
                return mustache_1.default.render(tpl, this.ctx);
            }
            return tpl;
        }
        render() {
            this.updateContext();
            const props = (0, cloneDeep_1.default)(this.props);
            // @ts-expect-error TS(2339): Property 'questions' does not exist on type 'Reado... Remove this comment to see the full error message
            const { questions, widgets, charLimits } = props;
            // @ts-expect-error
            props.nextBtnLabel = this.applyTemplate(props.nextBtnLabel);
            Object.keys(questions).forEach(questionId => {
                const question = (0, question_1.createQuestionModel)(questions, Number(questionId), charLimits);
                questions[questionId].label = this.applyTemplate(question.state.label);
                if ((0, question_models_1.isChoiceQuestionModel)(question)) {
                    // eslint-disable-next-line @typescript-eslint/unbound-method
                    question.mapOverAnswerLabels(this.applyTemplate);
                }
            });
            Object.keys(widgets).forEach(widgetId => {
                widgets[widgetId].label = this.applyTemplate(widgets[widgetId].label);
            });
            return (0, jsx_runtime_1.jsx)(WrappedComponent, Object.assign({}, props));
        }
    }
    return WithTemplate;
}
exports.default = withTemplate;
